import types from 'constants/actionTypes';

import { combineReducers } from 'redux';

import mergeByIds from '../../utils/mergeByIds';
 
const initialState = {

  byId: {},

  indexIds: [],

  modelIsActive: false,

  modelLockExpired: false,

};
 
const byId = (state = initialState.byId, { type, payload }) => {

  switch (type) {

    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS:

      return mergeByIds({

        byIdCurrent: state,

        byIdToMerge: payload?.entities?.models ?? {},

      });
 
    case types.GET_MODEL_TEMPLATES_SPECS_REQUEST_SUCCESS: {

      if (!payload?.result?.model) return state;
 
      let updatedModel = { ...(payload?.entities?.models ?? {}) };
 
      if (payload?.entities?.templates) {

        updatedModel[payload.result.model].templateIds = Object.keys(

          payload.entities.templates

        );

      }
 
      return mergeByIds({

        byIdCurrent: state,

        byIdToMerge: updatedModel,

      });

    }
 
    default:

      return state;

  }

};
 
const indexIds = (state = initialState.indexIds, { type, payload }) => {

  switch (type) {

    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS:

      return payload?.result?.models ?? state;

    default:

      return state;

  }

};
 
const modelIsActive = (state = initialState.modelIsActive, { type }) => {

  switch (type) {

    case types.SET_MODEL_IS_ACTIVE:

      return true;

    case types.SET_MODEL_IS_NOT_ACTIVE:

      return false;

    default:

      return state;

  }

};
 
const modelLockExpired = (state = initialState.modelLockExpired, { type }) => {

  switch (type) {

    case types.SET_MODEL_LOCK_EXPIRED:

      return true;

    case types.RESET_MODEL_LOCK_EXPIRED:

      return false;

    default:

      return state;

  }

};
 
export default combineReducers({

  byId,

  indexIds,

  modelIsActive,

  modelLockExpired,

});

 
